// Copyright 2026 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

// Pure display labels for the access tiers (functional core, no CSS/React) so
// the mapping is unit-testable. The TierBadge component is the imperative shell.

import { Tier } from '@simlin/core/tier';

// Friendly, freemium-facing labels. `public` reads as "Free" (the anonymous /
// build-only plan) rather than the internal enum name.
export const TIER_LABEL: Record<Tier, string> = {
  [Tier.Public]: 'Free',
  [Tier.Student]: 'Student',
  [Tier.Member]: 'Member',
  [Tier.Advanced]: 'Advanced',
};

export function tierLabel(tier: Tier): string {
  return TIER_LABEL[tier] ?? TIER_LABEL[Tier.Public];
}
